import { React, useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { MuiOtpInput } from 'mui-one-time-password-input';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAgentSignupStepCount, setOpenAgentLoginFlow, setAuthUserData, setOpenAgentSignupFlow } from "../../../redux/login";
import { ReactComponent as GoBackIcon } from "../../../assets/svg/arrow_back_icon.svg";
import { toast } from "react-toastify";
import { verifyEmailOtp, resendEmailOtp, verifyEmailOtpLogin } from "../../../services/LoginUser";
const AgentEmailVerification = () => {
  const [minutes, setMinutes] = useState(10);
  const [seconds, setSeconds] = useState(0);
  const [otp, setOtp] = useState("");
  const dispatch = useDispatch();
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [isVerifyDisabled, setIsVerifyDisabled] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const emailIdVerifiedAgent = JSON.parse(localStorage.getItem("email_verified"));

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      } else if (minutes > 0) {
        setMinutes(minutes - 1);
        setSeconds(59);
      } else {
        setIsResendDisabled(false);
        setIsVerifyDisabled(true);
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds, minutes]);
  const handleChange = (newValue) => {
    setOtp(newValue);
  };
  const handleSubmit = async () => {
    if (!otp || otp.length < 6) {
      toast.error(t("AgentEmailVerification.PleaseEnterOTP"), { autoClose: 2500 });
      return;
    }
    const email = localStorage.getItem("agentEmail");
    // const emailGet = JSON.parse(localStorage.getItem("email_verified"));

    const isVerified = await verifyEmailOtp(otp, email);
    if (isVerified) {
      toast.success(t("AgentEmailVerification.OTPVerifiedSuccessfully"), {
        autoClose: 2500,
        className: "toast-message",
        position: toast.POSITION.TOP_RIGHT,
      });
      dispatch(setAgentSignupStepCount(5));
    }
  };

  const handleLoginEmailNotVerify = async () => {
    if (!otp || otp.length < 6) {
      toast.error(t("AgentEmailVerification.PleaseEnterOTP"), { autoClose: 2500 });
      return;
    }
    // const emailAgent = localStorage.getItem("agentEmail");
    const email = JSON.parse(localStorage.getItem("email_verified"));

    const isVerified = await verifyEmailOtpLogin(otp, email);
    // const isVerified = await dispatch(verifyEmailOtpLogin(otp, email));
    if (isVerified) {
      toast.success(t("AgentEmailVerification.Congratulations"), {
        autoClose: 2500,
        className: "toast-message",
        position: toast.POSITION.TOP_RIGHT,
      });
      // dispatch(setAgentSignupStepCount(5));
      dispatch(setAuthUserData(isVerified));
      dispatch(setOpenAgentLoginFlow(false));
      dispatch(setOpenAgentSignupFlow(false));
      navigate("/agent-dashboard");
      localStorage.removeItem("email_verified");
    }
  };

  const handleResendOtp = async () => {
    const email = localStorage.getItem("agentEmail");
    const isOtpSent = await resendEmailOtp(email);

    if (isOtpSent) {
      toast.success(t("AgentEmailVerification.OTPResentSuccessfully"), { autoClose: 2500 });
      setMinutes(10);
      setSeconds(0);
      setIsResendDisabled(true);
      setIsVerifyDisabled(false);
    } else {
      toast.error(t("AgentEmailVerification.FailedToResendOTP"));
    }
  };

  const resendOtpEmailNotVerify = async () => {
    // const email = localStorage.getItem("agentEmail");
    const email = JSON.parse(localStorage.getItem("email_verified"));
    const isOtpSent = await resendEmailOtp(email);

    if (isOtpSent) {
      toast.success(t("AgentEmailVerification.OTPResentSuccessfully"), { autoClose: 2500 });
      setMinutes(10);
      setSeconds(0);
      setIsResendDisabled(true);
      setIsVerifyDisabled(false);
    } else {
      toast.error(t("AgentEmailVerification.FailedToResendOTP"));
    }
  };

  return (
    <>
      <Box sx={{ px: 5, pt: 3, pb: 4, background: '#FFFFFF' }}>
        {!emailIdVerifiedAgent && (
          <Button
            onClick={() => dispatch(setAgentSignupStepCount(3))}
            sx={{
              minWidth: 'auto',
              p: 1,
              mb: 2,
              borderRadius: '50%',
              color: '#64748B',
              '&:hover': { background: '#F1F5F9', color: '#0085FD' }
            }}
          >
            <GoBackIcon style={{ width: 24, height: 24 }} />
          </Button>
        )}

        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "1.75rem",
            color: "#1E293B",
            fontFamily: "Outfit, sans-serif",
            textAlign: 'center',
            width: '100%',
            mb: 1
          }}
        >
          {t("EmailVerification.AccountValidation")}
        </Typography>
        <Typography
          sx={{
            fontSize: "0.875rem",
            color: "#64748B",
            textAlign: "center",
            mb: 4
          }}
        >
          {t("EmailVerification.ThankYouForSigningUpText")}
        </Typography>

        <Box sx={{ mb: 4 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: 'center', mb: 2 }}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "1rem",
                color: "#1E293B",
                fontFamily: "Outfit, sans-serif"
              }}
            >
              {t("EmailVerification.Otp")}
            </Typography>
            <Typography
              sx={{
                fontSize: "0.875rem",
                color: minutes === 0 && seconds < 30 ? "#EF4444" : "#64748B",
                fontWeight: 600,
                fontFamily: "monospace"
              }}
            >
              {minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}
            </Typography>
          </Box>

          <MuiOtpInput
            length={6}
            value={otp}
            onChange={handleChange}
            TextFieldProps={{
              sx: {
                '& .MuiOutlinedInput-root': {
                  borderRadius: '12px',
                  bgcolor: '#F8FAFC',
                  '& fieldset': { borderColor: '#E2E8F0' },
                  '&:hover fieldset': { borderColor: '#0085FD' },
                  '&.Mui-focused fieldset': { borderColor: '#0085FD' },
                },
                '& .MuiInputBase-input': {
                  fontSize: '1.25rem',
                  fontWeight: 700,
                  color: '#1E293B'
                }
              }
            }}
          />
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Button
            variant="contained"
            disableElevation
            fullWidth
            disabled={isVerifyDisabled}
            onClick={() => {
              if (emailIdVerifiedAgent) {
                handleLoginEmailNotVerify();
              } else {
                handleSubmit();
              }
            }}
            sx={{
              bgcolor: "#0085FD",
              color: "white",
              py: 1.5,
              borderRadius: "10px",
              textTransform: 'none',
              fontSize: '1rem',
              fontWeight: 600,
              "&:disabled": { bgcolor: "#E2E8F0", color: "#94A3B8" },
              "&:hover": { bgcolor: "#0072DB" }
            }}
          >
            {t("AgentEmailVerification.Verify")}
          </Button>

          <Button
            variant="outlined"
            fullWidth
            disabled={isResendDisabled}
            onClick={() => {
              if (emailIdVerifiedAgent) {
                resendOtpEmailNotVerify();
              } else {
                handleResendOtp();
              }
            }}
            sx={{
              color: "#0085FD",
              borderColor: "#0085FD",
              py: 1.5,
              borderRadius: "10px",
              textTransform: 'none',
              fontSize: '1rem',
              fontWeight: 600,
              "&:disabled": { borderColor: "#E2E8F0", color: "#94A3B8" },
              "&:hover": { bgcolor: "rgba(0, 133, 253, 0.05)", borderColor: "#0072DB" }
            }}
          >
            {t("AgentEmailVerification.ResendOTP")}
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default AgentEmailVerification;